module.exports = __webpack_public_path__ + "static/media/greenMapMarker.19a6aa96.png";